const InformationPractitionersIndex = r => require.ensure([], () => r(require('@/page/Information-of-Practitioners/StatisticsParking/InformationPractitionersIndex')), 'InformationPractitionersIndex');
const InformationPractitionersView = r => require.ensure([], () => r(require('@/page/Information-of-Practitioners/StatisticsParking/InformationPractitionersView')), 'InformationPractitionersView');
const ProjectIndexParking = r => require.ensure([], () => r(require('@/page/Information-of-Practitioners/StatisticsParking/StatisticsParkingTable/ProjectIndexParking')), 'ProjectIndexParking');
const PropertyPeople = r => require.ensure([], () => r(require('@/page/Information-of-Practitioners/StatisticsParking/StatisticsParkingTable/Property-People')), 'PropertyPeople');


const InformationOfPractitionersRouter = {
    path: '',
    name: '从业人员信息统计',
    component: InformationPractitionersView,
    meta: {
      right: [],
      isShowMenu: true,
      icon: 'organMge',
  },
    children: [
        {
            path: '/InformationPractitionersIndex',
            component: InformationPractitionersIndex,
            name: '从业人员信息统计',
            meta: {
                right: [],
                isShowMenu: true,
                keepAlive: true,
            },
        },
        {
          path: '/ProjectIndexParking',
          component: ProjectIndexParking,
          name: '项目统计',
          meta: {
              right: [],
          },
      },
      {
        path: '/PropertyPeople',
        component: PropertyPeople,
        name: '人员统计',
        meta: {
            right: [],
        },
    },

    ]
};
export default InformationOfPractitionersRouter;